import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from 'antd';
import NavBar from './components/NavBar/NavBar';
import LandingPage from './components/LandingPage/LandingPage';

function App() {
  return (
    <Router>
      <Layout>
        <div>
          <div style={{ position: 'fixed', top: 0, left: 0, right: 0, backgroundColor: '#A8CCC9', zIndex: 1000 }}>
            <NavBar />
          </div>
          <div style={{ paddingBottom: '150px', backgroundColor: '#75B9BE' }}>
            <Routes>
              <Route path="/" element={<LandingPage />}/>
            </Routes>
          </div>
        </div>
      </Layout>
    </Router>
  );
}

export default App;
